module.exports = __webpack_public_path__ + "static/media/reviva_thumb.5eaa5c46.webp";